import React, { useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { SocialIcon } from 'react-social-icons';

import './NavBar.css';

export default function NavBar() {
  const onCollapse = (e) => {
    if(window.innerWidth > 610) {
      return;
    }
    const elm = e.currentTarget;
    const first = elm.getBoundingClientRect();
    if(first.height > 114) {
      elm.style.height = '80px';
      document.getElementById('root').style.paddingTop = '80px'
    } else {
      elm.style.height = 'auto';
      document.getElementById('root').style.paddingTop = '376px'
    }
    const last = elm.getBoundingClientRect();
    const deltaX = first.left - last.left;
    const deltaY = first.top - last.top;
    const deltaW = first.width / last.width;
    const deltaH = first.height / last.height;
    elm.animate([{
      transformOrigin: 'top left',
      transform: `
        translate(${deltaX}px, ${deltaY}px)
        scale(${deltaW}, ${deltaH})
      `
    }, {
      transformOrigin: 'top left',
      transform: 'none'
    }], {
      duration: 300,
      easing: 'ease-in-out',
      fill: 'both'
    });
  }

  useEffect(() => {
    window.onresize = () => {
      if(window.innerWidth > 610) {
        const root = document.getElementById('root');
        const header = root.querySelector("header");
        header.style.height = 'auto';
        root.style.paddingTop = '107px';
      }
    }
  }, [])

  return (
    <header className="bg-red-600 fixed w-full top-0" onClick={onCollapse}>
      <div className="container mx-auto flex justify-between">
        <nav className="flex">
          <span
            style={{cursor: 'pointer'}}
            className="pointer inline-flex items-center py-6 px-3 mr-4 my-2 text-red-100 text-4xl font-bold cursive tracking-widest w-42 h-42 toggler sm:hidden"
          >
            <svg style={{width: 42, height: 42}} className="w-42 h-42" viewBox="0 0 1024 1024" width="1024" height="1024"><path d="M921.6 238.90944c0 29.45024-23.86944 53.3248-53.31968 53.3248H155.71968C126.27456 292.23424 102.4 268.35968 102.4 238.90944c0-29.44512 23.87456-53.31968 53.31968-53.31968h712.56064c29.45024 0 53.31968 23.87456 53.31968 53.31968zM921.6 512c0 29.45024-23.86944 53.31968-53.31968 53.31968H155.71968C126.27456 565.31968 102.4 541.45024 102.4 512s23.87456-53.31968 53.31968-53.31968h712.56064C897.73056 458.68032 921.6 482.54976 921.6 512zM921.6 785.08544c0 29.45024-23.86944 53.3248-53.31968 53.3248H155.71968c-29.44512 0-53.31968-23.87456-53.31968-53.3248 0-29.44512 23.87456-53.31968 53.31968-53.31968h712.56064c29.45024 0 53.31968 23.87456 53.31968 53.31968z"></path></svg>
          </span>
          <NavLink 
            exact 
            to="/" 
            activeClassName="text-white"
            className="inline-flex items-center py-6 px-3 mr-4 text-red-100 hover:text-green-800 text-4xl font-bold cursive tracking-widest"
          >
              Marvin
          </NavLink>
          <NavLink 
            to="/post"
            className="inline-flex items-center py-3 px-3 my-6 rounded text-red-200 hover:text-green-800"
            activeClassName="text-red-100 bg-red-700"
          >
            Blog Posts
          </NavLink>
          <NavLink 
            to="/project"
            className="inline-flex items-center py-3 px-3 my-6 rounded text-red-200 hover:text-green-800"
            activeClassName="text-red-100 bg-red-700"
          >
            Projects
          </NavLink>
          <NavLink 
            to="/about"
            className="inline-flex items-center py-3 px-3 my-6 rounded text-red-200 hover:text-green-800"
            activeClassName="text-red-100 bg-red-700"
          >
            About Me
          </NavLink>
        </nav>
        <div className="inline-flex py-3 px-3 my-6">
          <SocialIcon 
            url="https://github.com/nfwyst" 
            className="mr-4" 
            target="_blank" 
            fgColor="#fff" 
            style={{ height: 35, width: 35}} 
          />
        </div>
      </div>
    </header>
  )
}
